import '@uirouter/angularjs';
import '@uirouter/angularjs/release/stateEvents';

/**
 * Expose UI Router's AngularJS packages on the window so they can be consumed
 * by service packs using `@msx/webpack-externals`.
 */

import * as uiRouterNg1 from '@uirouter/angularjs';

const msxUIRouter = window.msxUIRouter || {};

msxUIRouter.angularjs = uiRouterNg1;

window.msxUIRouter = msxUIRouter;
